"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePTTQuery = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactQuery = require("react-query");

var _utils = require("../utils/utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

/**
 * Wrapper around react-query's useQuery
 * @deprecated - use react-query useQuery() instead.
 */
var usePTTQuery = function usePTTQuery(_ref) {
  var baseUrl = _ref.baseUrl,
      queryName = _ref.queryName,
      queryKeys = _ref.queryKeys,
      queryOptions = _ref.queryOptions,
      fetchOptions = _ref.fetchOptions,
      onFirstSuccess = _ref.onFirstSuccess;

  var firstSuccess = _react["default"].useRef(false); // The function called for fetching data


  var fetchFunction = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(function* () {
      var response = yield (0, _utils.pttFetch)(baseUrl, fetchOptions);
      return response.data;
    });

    return function fetchFunction() {
      return _ref2.apply(this, arguments);
    };
  }();

  var queryClient = (0, _reactQuery.useQueryClient)();
  var query = (0, _reactQuery.useQuery)((0, _utils.getQueryKey)(queryName, queryKeys), fetchFunction, queryOptions);

  _react["default"].useEffect(function () {
    if (onFirstSuccess && !firstSuccess.current) {
      if (query.isSuccess && !query.isRefetching) {
        firstSuccess.current = true;
        onFirstSuccess(query);
      }
    }
  }); // No dependencies, we want this at each render


  return _objectSpread(_objectSpread({}, query), {}, {
    invalidate: function invalidate() {
      return queryClient.invalidateQueries(queryName);
    },
    firstSuccess: firstSuccess.current || query.isSuccess && !query.isRefetching
  });
};

exports.usePTTQuery = usePTTQuery;